import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./MetersOverviewPage.less');

const MetersOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/buyer/meters/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
		{
			key: 'types/overview',
			name: 'Types',
		},
	];

	return (
		<>
			<Route
				path="/buyer/meters/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/buyer/meters/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Meters"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="metersPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(MetersOverviewPage)
);
